import * as yup from 'yup';

export const loginFormSchema = yup
  .object({
    email: yup.string().email().label('Email').required(),
    password: yup.string().label('Password').required()
  })
  .required();
